
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.33 9.23L1.437 6.337A.83.83 0 10.263 7.513l3.483 3.483a.83.83 0 001.175 0l8.817-8.817a.83.83 0 10-1.175-1.175L4.329 9.23z","fill":"#fff"}})])
          )
        }
      }
    